export const mapObject = (object, callbackFn) => Object.entries(object).map(callbackFn)

export default mapObject
